import { IntlShape, useIntl } from "react-intl"
import { isEmpty, toUpper } from "lodash"
import { User } from "~/types/api/UserTypes"

interface Literals {
  fullName: string
  initials: string
}

export interface Message {
  id: string
}

const getFullName = (user: User, formatMessage: IntlShape["formatMessage"]) => {
  if (user.isFakeUser) {
    return formatMessage({ id: "entity.user.fakeUser" })
  }
  if (user.fullName) {
    return user.fullName
  }

  if (user.lastName || user.firstName) {
    return `${user.lastName} ${user.firstName}`
  }

  return null
}

const getInitials = (user: User) => {
  if (user.isFakeUser || user.fullName === "fakeUser") {
    return "--"
  }

  const firstNameInitial = user.firstName || "-"
  const lastNameInitial = user.lastName || "-"
  return toUpper(`${firstNameInitial[0]}${lastNameInitial[0]}`)
}

export const getLiterals = (user: User, formatMessage: IntlShape["formatMessage"]): Literals => {
  if (isEmpty(user)) {
    return null
  }

  return {
    fullName: getFullName(user, formatMessage),
    initials: getInitials(user),
  }
}

export const getUsername = (user: User, formatMessage: IntlShape["formatMessage"]): string => {
  if (isEmpty(user)) {
    return null
  }

  return getFullName(user, formatMessage)
}

interface UserNameType {
  user: User
}

const UserName = ({ user }: UserNameType): JSX.Element => {
  const intl = useIntl()
  // eslint-disable-next-line @typescript-eslint/unbound-method
  return <>{getUsername(user, intl.formatMessage)}</>
}

export default UserName
